import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": ""
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Edit Drafts", -1);
var _hoisted_3 = {
  "class": "bg-white border rounded-md shadow p-4"
};
var _hoisted_4 = {
  "class": "mb-6 w-full flex justify-start"
};
var _hoisted_5 = {
  "class": "w-1/3"
};
var _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant", -1);
var _hoisted_7 = {
  "class": "w-1/3"
};
var _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Campaign", -1);
var _hoisted_9 = {
  "class": "w-1/3 flex gap-2"
};
var _hoisted_10 = {
  "class": "bg-white border rounded-md shadow p-4 mt-8"
};
var _hoisted_11 = {
  key: 0,
  "class": "w-full border-l border border-fborder"
};
var _hoisted_12 = {
  id: "followUpsCntr",
  "class": "p-4 h-full"
};
var _hoisted_13 = {
  "class": "flex items-center gap-3"
};
var _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/envelope.svg",
  "class": "w-4"
}, null, -1);
var _hoisted_15 = {
  "class": "text-sm font-bold"
};
var _hoisted_16 = {
  "class": "text-sm font-bold"
};
var _hoisted_17 = {
  "class": "relative mt-4"
};
var _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  "for": "email",
  "class": "text-sm font-bold"
}, "Subject", -1);
var _hoisted_19 = ["onUpdate:modelValue"];
var _hoisted_20 = {
  "class": "bg-red-100 p-2 border-2 border-fsecondary shadow-md rounded-md flex justify-between items-center"
};
var _hoisted_21 = {
  "class": "flex justify-start items-center"
};
var _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  "class": "px-2"
}, [/*#__PURE__*/_createElementVNode("i", {
  "class": "fi-rs-exclamation"
})], -1);
var _hoisted_23 = {
  "class": "text-sm"
};
var _hoisted_24 = {
  "class": "bg-red-100 p-2 border-2 border-fsecondary shadow-md rounded-md flex justify-between items-center"
};
var _hoisted_25 = {
  "class": "flex justify-start items-center"
};
var _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  "class": "px-2"
}, [/*#__PURE__*/_createElementVNode("i", {
  "class": "fi-rs-exclamation"
})], -1);
var _hoisted_27 = {
  "class": "text-sm"
};
var _hoisted_28 = {
  "class": "p-1 border border-blue-500 focus:outline-none rounded-md focus:border-fborder-dark focus:shadow-sm mt-4"
};
var _hoisted_29 = {
  "class": "w-full flex justify-between gap-3 py-3"
};
var _hoisted_30 = ["onClick"];
var _hoisted_31 = ["onClick"];
var _hoisted_32 = ["onClick"];
var _hoisted_33 = {
  "class": "flex items-center gap-3 pt-4"
};
var _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/envelope.svg",
  "class": "w-4"
}, null, -1);
var _hoisted_35 = {
  "class": "text-sm font-bold"
};
var _hoisted_36 = {
  "class": "text-sm font-bold"
};
var _hoisted_37 = /*#__PURE__*/_createElementVNode("hr", {
  "class": "flex-1 h-1 border-0 border-b border-fborder"
}, null, -1);
var _hoisted_38 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-xs bg-gray-100 p-1 rounded-md"
}, "Click anywhere inside to edit", -1);
var _hoisted_39 = {
  "class": "p-8"
};
var _hoisted_40 = {
  "class": "pb-4"
};
var _hoisted_41 = ["innerHTML"];
var _hoisted_42 = /*#__PURE__*/_createElementVNode("h4", {
  "class": "text-center capitalize"
}, "Email Preview", -1);
var _hoisted_43 = {
  "class": "draft-email-card-to"
};
var _hoisted_44 = {
  "class": "draft-email-to"
};
var _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  "class": "text-sm font-medium text-ftext"
}, "To", -1);
var _hoisted_46 = {
  "class": "flex-1 p-2 relative"
};
var _hoisted_47 = {
  "class": "draft-card-subject"
};
var _hoisted_48 = {
  "class": "flex items-center"
};
var _hoisted_49 = {
  "class": "text-sm"
};
var _hoisted_50 = {
  "class": "border border-fborder"
};
var _hoisted_51 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_Editor = _resolveComponent("Editor");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_TagsInput = _resolveComponent("TagsInput");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "Edit Drafts"
  }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_select, {
    modelValue: $data.selectedTenant,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.selectedTenant = $event;
    }),
    placeholder: "Tenant",
    "class": "mt-4",
    filterable: "",
    onChange: $options.updatecampaignList
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenantList, function (t) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: t.id,
          label: t.id
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
    modelValue: $data.selectedCampaign,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.selectedCampaign = $event;
    }),
    placeholder: "Campaign",
    "class": "mt-4",
    filterable: "",
    onChange: $options.updateCadence
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.campaignList, function (c) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: c.id,
          label: c.name
        }, {
          "default": _withCtx(function () {
            return [_createElementVNode("span", {
              "class": _normalizeClass(["dot mr-2", {
                'green': c.status == 'active',
                'gray': c.status == 'pending',
                'yellow': c.status == 'pause',
                'red': c.status == 'suspended'
              }])
            }, null, 2), _createTextVNode(_toDisplayString(c.name), 1)];
          }),
          _: 2
        }, 1032, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
    "class": "text-white focus:text-indigo-500 text-sm bg-indigo-800 p-3 rounded-md mt-5",
    type: "button",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.getDrafts && $options.getDrafts.apply($options, arguments);
    })
  }, "Show Drafts")])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingDrafts,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [Object.keys($data.cadence).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cadence.follow_ups, function (fp, f_key) {
        return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
          ref_for: true,
          ref: $options.getCntrId(f_key)
        }, null, 512), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$helpers.stringifyNumber(fp.follow_up_order)), 1), _createElementVNode("span", _hoisted_16, "(Last Updated On - " + _toDisplayString(fp.last_updated) + ")", 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return fp.subject = $event;
          },
          type: "text",
          id: "email",
          "class": "text-sm border border-blue-500 focus:outline-none rounded-md focus:border-fborder-dark focus:shadow-sm w-full p-3 mt-1",
          placeholder: "",
          autocomplete: "off",
          onKeyup: _cache[3] || (_cache[3] = function ($event) {
            return _ctx.showWarning = true;
          })
        }, null, 40, _hoisted_19), [[_vModelText, fp.subject]])]), _withDirectives(_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(fp.sub_error_msg), 1)])], 512), [[_vShow, fp.show_sub_error]]), _withDirectives(_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("span", _hoisted_27, _toDisplayString(fp.mail_error_msg), 1)])], 512), [[_vShow, fp.show_mail_error]]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_Editor, {
          modelValue: fp.body,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return fp.body = $event;
          },
          ref_for: true,
          ref: $options.getEditorRef(f_key),
          height: "100%",
          onKeyup: _cache[4] || (_cache[4] = function ($event) {
            return _ctx.showWarning = true;
          })
        }, null, 8, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
          "class": "text-white focus:text-indigo-500 text-sm bg-indigo-800 p-1 rounded-md",
          onClick: function onClick($event) {
            return $options.showDraftPreview(f_key);
          }
        }, " Preview Draft ", 8, _hoisted_30), _createElementVNode("button", {
          "class": "text-white focus:text-indigo-500 text-sm bg-indigo-800 p-1 rounded-md",
          onClick: function onClick($event) {
            return $options.saveDraft(f_key);
          }
        }, " Save " + _toDisplayString(_ctx.$helpers.stringifyNumber(fp.follow_up_order)) + " Draft ", 9, _hoisted_31)])], 512), [[_vShow, f_key == $data.currentFollowUp]]), _withDirectives(_createElementVNode("div", {
          onClick: function onClick($event) {
            return $data.currentFollowUp = f_key;
          },
          "class": "cursor-pointer"
        }, [_createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$helpers.stringifyNumber(f_key)), 1), _createElementVNode("span", _hoisted_36, "(Last Updated On - " + _toDisplayString(fp.last_updated) + ")", 1), _hoisted_37, _hoisted_38]), _createElementVNode("div", _hoisted_39, [_createElementVNode("p", _hoisted_40, "Subject: " + _toDisplayString(fp.subject), 1), _createElementVNode("div", {
          innerHTML: fp.body
        }, null, 8, _hoisted_41)])], 8, _hoisted_32), [[_vShow, f_key != $data.currentFollowUp]])]);
      }), 256))])])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["loading"])])]), _createVNode(_component_el_dialog, {
    modelValue: $data.showPreview,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.showPreview = $event;
    }),
    top: "5vh",
    center: ""
  }, {
    header: _withCtx(function () {
      return [_hoisted_42];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("button", {
        "class": "btn-primary",
        type: "button",
        onClick: _cache[6] || (_cache[6] = function () {
          return $options.sendPreviewMail && $options.sendPreviewMail.apply($options, arguments);
        })
      }, "Send a sample email")];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [_createVNode(_component_TagsInput, {
        modelValue: $data.previewMailTo,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return $data.previewMailTo = $event;
        })
      }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("span", _hoisted_49, "Subject: " + _toDisplayString($data.preview_subject), 1)])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", {
        "class": "max-h-[50vh] w-full text-left overflow-auto p-3 text-sm",
        innerHTML: $data.preview_body
      }, null, 8, _hoisted_51)])])];
    }),
    _: 1
  }, 8, ["modelValue"])], 64);
}